// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2137":"1994fb26","2294":"454d7c6d","3570":"45ff4e56","5862":"e4a999df","7017":"4d6c22f7"}[chunkId] + ".chunk.css";
};